export type Settings = {
    pat: string;
    org: string;
    project: string;
};

export const ORG_OPTIONS = ['nuxni'] as const;
export const PROJECT_OPTIONS = ['C2D'] as const;

export const emptySettings: Settings = {
    pat: '',
    org: ORG_OPTIONS[0],
    project: PROJECT_OPTIONS[0],
};

export const isConfigured = (s: Settings): boolean => s.pat.trim() !== '' && s.org.trim() !== '' && s.project.trim() !== '';

export type TeamMember = {
    email: string;
    name: string;
    department: string;
    daysOff: string[];
    startDate: string | null;
    endDate: string | null;
    lastModifiedOn: string;
    updatedBy: string;
};

export type SetDaysOffCommand = {
    daysOff: string[];
};
